import { render, staticRenderFns } from "./AddCustomer.vue?vue&type=template&id=223cbaf5&"
import script from "./AddCustomer.vue?vue&type=script&lang=ts&"
export * from "./AddCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./AddCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports